import TextInput from "../../../../../form/inputs/TextInput";
import {verticalFormLayout} from "../../../../../form/styles/layout";
import {Form, Formik} from "formik";
import {useRepo} from "../../../../../../repos/useRepo";
import {updateSubmitHandler} from "../../../../../form/helpers/formSubmit";
import {actions} from "../../../../../../rbac";
import {useRbac} from "@gsb/react-rbac";
import {UpdateSubjectIdRequest} from "../../../../../../repos/user/UserRepo";
import {User} from "../../../../../../models/User";
import React from "react";
import {FormSubmitButton} from "../../../../../form/buttons/FormSubmitButton";
import {updateSubjectIdSchema} from "./update-subjectid-schema";

interface Props {
    user: User;
    onUserUpdated: (user: User) => void
}

export function UpdateSubjectIdForUserForm({ user, onUserUpdated }: Props) {
    const { userRepo } = useRepo();

    const { can } = useRbac();
    const disabled = !can(actions.user.updateSubjectId);

    const onSubmit = updateSubmitHandler(
        (body: UpdateSubjectIdRequest) => userRepo.updateSubjectIdForUserById(user.id, body),
        initialValues,
        onUserUpdated,
        console.error
    );

    return (
        <Formik enableReinitialize={true}
                initialValues={initialValues(user)}
                validationSchema={updateSubjectIdSchema}
                onSubmit={onSubmit} >
            <Form style={verticalFormLayout}>
                <TextInput name='subjectId' label='Subject Id' disabled={disabled} />
                <FormSubmitButton style={{ alignSelf: 'flex-end' }} variant='Update' disabled={disabled}/>
            </Form>
        </Formik>
    )
}

const initialValues = (user: User) => ({
    subjectId: user.subjectId ?? ''
})
